import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { DownloadIcon } from '@treams/treams-icons';
import type * as graphql from '@treams/treams-network';
import { Button, Paragraph, Popover, Subheading } from '@treams/treams-ui';

import DashboardDownloadScores from './downloads/DashboardDownloadScores';

type AnalyticsDownloadsProps = {
	filters: graphql.AnalyticsFiltersV2;
};

export function AnalyticsDownloads(props: AnalyticsDownloadsProps) {
	const { t } = useTranslation();

	const filters = {
		startDate: props.filters.startDate,
		endDate: props.filters.endDate,
		groupIDs: props.filters.groups?.map((group) => group.id),
	};

	const [visible, setVisible] = useState(false);

	return (
		<Popover.Target
			visible={visible}
			contents={
				<Box p={3}>
					<Subheading>{t('dashboard.sidebar.downloads.title')}</Subheading>
					<Paragraph mb={3}>
						<a target="_blank" href={t('dashboard.sidebar.downloads.info.link')} rel="noreferrer">
							{t('dashboard.sidebar.downloads.info.button')}
						</a>
					</Paragraph>
					<DashboardDownloadScores filters={filters} />
				</Box>
			}
			onDismiss={() => setVisible(false)}
		>
			<Button
				icon={<DownloadIcon />}
				title={t('dashboard.sidebar.downloads.title')}
				type="secondary"
				onClick={() => setVisible(true)}
			/>
		</Popover.Target>
	);
}
